export default [
  {
    name: 'defaultList',
    path: 'list',
    component: () => import(/* webpackChunkName: 'defaultList' */ '../views/patient/list/index.vue'),
    meta: {
      keepAlive: true,
    },
  },
  {
    name: 'defaultGroup',
    path: 'group',
    component: () => import(/* webpackChunkName: 'defaultGroup' */ '../views/patient/list/group.vue'),
  },
  {
    name: 'defaultDetail',
    path: 'detail',
    component: () => import(/* webpackChunkName: 'defaultDetail' */ '../views/patient/detail/index.vue'),
  },
  {
    name: 'defaultTagManage',
    path: 'tagManage',
    component: () => import(
      /* webpackChunkName: 'tagManage' */
      '../views/patient/tagManage/index.vue'),
    meta: {
      tabGroup: 'defaultTestPatient',
    },
  },
  {
    name: 'defaultTestPatientDetail',
    path: 'testPatientDetail',
    component: () => import(
      /* webpackChunkName: 'testPatientDetail' */
      '../views/test-patient/detail/index.vue'),
    meta: {
      tabGroup: 'defaultTestPatient',
    },
  },
];
